module.exports = __webpack_public_path__ + "img/video.4a7cfd88.png";